// extracted by mini-css-extract-plugin
export default {"container":"_2cm3mZ_","pill":"_2Ozs2z5","hidden":"_16s8NNi"};